<template>
    <div id="app" ref="app">
      <Header v-if="gsFriendUserId != ''"></Header>
      <div class="deadlock-bg" v-if="notHasGameData == 2"></div>
      <div class="deadlock" v-if="notHasGameData == 1">
        <div class="deadlock-title">
          <img class="title-img" src="../../assets/image/deadlock/deadlockIcon@.png" alt=""/>
        </div>
        <div class="deadlock-content">
          <swiper 
            class="swiper"
            :options="swiperOptions">
            
            <swiper-slide><img class="swiper-img" src="../../assets/image/deadlock/左侧预览图.png"></swiper-slide>
            <swiper-slide><img class="swiper-img" src="../../assets/image/deadlock/中间预览图@3x.png"></swiper-slide>
            <swiper-slide><img class="swiper-img" src="../../assets/image/deadlock/右侧预览图.png"></swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
          
        </div>
        <div class="deadlock-btn" @click="getBindAccountToSteam()">立即绑定</div>
        <div class="deadlock-report" @click="gotoReport()" >意见反馈</div>
      </div>
      <div class="deadlockDataPage" v-if="notHasGameData == 2">
        <div class="deadlockDataPageTitle">
          <div class="deadlockDataPageTitleLeft">
            <div class="deadlockDataPageTitleLeftHeadIMG">
              <img :src="userSteamAvatar ? userSteamAvatar : gsFriendUserAvatar ? gsFriendUserAvatar : require('../../assets/image/deadlock/icon_MoRenTouXiang_36x36@3x.png')" alt=""/>
            </div>
            <div class="deadlockDataPageTitleLeftName">{{ userSteamName ? userSteamName : gsFriendUserName }}</div>
          </div>
          <div class="deadlockDataPageTitleRight" v-if="gsFriendUserId == ''">
            <div class="deadlockDataPageTitleRightTimeShow" v-if="baseTracker.updateTimeDesc">
              <div class="deadlockDataPageTitleRightTimeShowText">{{ baseTracker.updateTimeDesc }}</div>
            </div>
            <div class="archiveInfo-refresh" @click="refreshData()">
                <div :class="{ cur: isFreshing }"><i></i>刷新{{ isFreshing ? "中" : "" }}</div>
            </div>
          </div>
        </div>
        <div class="deadlockDataPageOverViewData">
          <div class="Matchs OverViewData">
            <div class="MatchsData OverViewDataInfo" :class="{ noData: !baseTracker.totalMatch }">{{  baseTracker.totalMatch ? baseTracker.totalMatch : "--" }}</div>
            <div class="MatchsDataText OverViewDataText">总场数</div>
          </div>
          <div class="WinPercent OverViewData">
            <div class="WinPercentData OverViewDataInfo" :class="{ noData: !baseTracker.winRate }">{{ baseTracker.winRate ? baseTracker.winRate : "--" }}</div>
            <div class="WinPercentDataText OverViewDataText">胜率</div>
          </div>
          <div class="KDA OverViewData">
            <div class="KDAData OverViewDataInfo" :class="{ noData: !baseTracker.kda }">{{ baseTracker.kda ? baseTracker.kda : "--" }}</div>
            <div class="KDAText OverViewDataText">KDA</div>
          </div>
          <div class="AverageEconomy OverViewData">
            <div class="AverageEconomyData OverViewDataInfo" :class="{ noData: !baseTracker.networthPerMin }">{{ baseTracker.networthPerMin ? baseTracker.networthPerMin : "--" }}</div>
            <div class="AverageEconomyDataText OverViewDataText">分均经济</div>
          </div>
          <div class="HitRate OverViewData">
            <div class="HitRateData OverViewDataInfo" :class="{ noData: !baseTracker.accuracy }">{{ baseTracker.accuracy ? baseTracker.accuracy : "--" }}</div>
            <div class="HitRateDataText OverViewDataText">命中率</div>
          </div>
          <div class="HeadExplosionRate OverViewData">
            <div class="HeadExplosionRateData OverViewDataInfo" :class="{ noData: !baseTracker.critShotRate }">{{ baseTracker.critShotRate ? baseTracker.critShotRate : "--" }}</div>
            <div class="HeadExplosionRateDataText OverViewDataText">爆头率</div>
          </div>
          <div class="CreepsPerMinute OverViewData">
            <div class="CreepsPerMinuteData OverViewDataInfo" :class="{ noData: !baseTracker.creepsPerMin }">{{ baseTracker.creepsPerMin ? baseTracker.creepsPerMin : "--" }}</div>
            <div class="CreepsPerMinuteDataText OverViewDataText">每分钟补刀</div>
          </div>
          <div class="DeniesPerMinute OverViewData">
            <div class="DeniesPerMinuteData OverViewDataInfo" :class="{ noData: !baseTracker.deniesPerMin }">{{ baseTracker.deniesPerMin ? baseTracker.deniesPerMin : "--" }}</div>
            <div class="DeniesPerMinuteDataText OverViewDataText">每分钟反补</div>
          </div>
        </div>
        <div class="deadlockDataPageLogo">
          <div class="deadlockDataPageLogoImg"></div>
        </div>
        <div class="deadlockDataPageMatchList">
          <div class="deadlockDataPageMatchListTitle" @click="jumpToMatchList(matchTrackerList.length)">
            <div class="deadlockDataPageMatchListTitleLeft">近期战绩</div>
            <div class="deadlockDataPageMatchListTitleRight"  v-if="matchTrackerList.length > 0">
              <div class="deadlockDataPageMatchListTitleRightText">全部比赛</div>
              <div class="deadlockDataPageMatchListTitleRightIcon"></div>
            </div>
          </div>
          <div class="deadlockDataPageMatchListContent"  v-if="matchTrackerList.length > 0">
            <div class="deadlockDataPageMatchListContentHeader">
              <div class="deadlockDataPageMatchListFormTitleResult matchListFormTitleItem grid-row">结果</div>
              <div class="matchListFormGap grid-row" style="max-width: 31px"></div>
              <div class="deadlockDataPageMatchListFormTitleHero matchListFormTitleItem grid-row">英雄</div>
              <div class="matchListFormGap grid-row" style="max-width: 35px"></div>
              <div class="deadlockDataPageMatchListFormTitleKDA matchListFormTitleItem grid-row">KDA</div>
              <div class="matchListFormGap grid-row" style="max-width: 36px"></div>
              <div class="deadlockDataPageMatchListFormTitleSoulIcon grid-row"></div>
              <div class="deadlockDataPageMatchListFormTitleSoulAndTime matchListFormTitleItem grid-row">灵魂/时长</div>
            </div>
            <div class="deadlockDataPageMatchListContentInfo">
              <div class="deadlockDataPageMatchListFormItem grid-row" v-for="(item, index) in matchTrackerList" :key="index">
                <div class="deadlockDataPageMatchListFormFormItemResult grid-row">
                  <div :class="item.matchResult ? 'deadlockDataPageMatchListFormItemResultLineSuccess' : 'deadlockDataPageMatchListFormItemResultLineFail'"></div>
                  <div class="deadlockDataPageMatchListFormItemResultInfo">
                    <div class="matchsResultTest" :class="item.matchResult ? 'matchsResultSuccess' : 'matchsResultFail'">{{ item.matchResult ? "胜利" : "失败" }}</div>
                    <div class="matchsDate">{{ item.matchTimeDesc }}</div>
                  </div>
                </div>
                <div class="matchListFormGap grid-row" style="max-width: 31px"></div>
                <div class="deadlockDataPageMatchListFormFormItemHeroBox grid-row">
                  <div class="deadlockDataPageMatchListFormFormItemHero ">
                    <img :src="item.heroImage" alt="">
                    <div class="deadlockDataPageMatchListFormItemHeroLevel">{{ item.heroLevel }}</div>
                  </div>
                </div>
                <div class="matchListFormGap grid-row" style="max-width: 35px"></div>
                <div class="deadlockDataPageMatchListFormFormItemKDA grid-row">
                  <div class="deadlockDataPageMatchListFormItemKDA">{{ item.kda }}</div>
                  <div class="deadlockDataPageMatchListFormItemKDAData">
                    <div class="deadlockDataPageMatchListFormItemKDADataInfo">
                      <div class="kill KDAInfo">{{ '&nbsp;' + item.playerKills }}</div>
                      <i class="KDAdivider">/</i>
                      <div class="death KDAInfo">{{ '&nbsp;' + item.playerDeaths }}</div>
                      <i class="KDAdivider">/</i>
                      <div class="assists KDAInfo">{{ '&nbsp;' + item.playerAssists }}</div>
                    </div>
                  </div>
                </div>
                <div class="matchListFormGap grid-row" style="max-width: 36px"></div>
                <div class="deadlockDataPageMatchListFormFormItemSoulIcon grid-row">
                  <img :src="require('../../assets/image/deadlock/icon_LingHun_16x16.svg')" alt="">
                </div>
                <div class="deadlockDataPageMatchListFormFormItemSoulAndTime grid-row">
                  <div class="deadlockDataPageMatchListFormItemSoul">{{ item.netWorth }}</div>
                  <div class="deadlockDataPageMatchListFormItemUseTime">{{ item.matchDurationDesc }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="deadlockDataPageMatchListContentOfNone" v-else>
            <div class="deadlockDataPageMatchListContentHeaderNone">
              <div class="deadlockDataPageMatchListFormTitleResultNone matchListFormTitleItem">结果</div>
              <div class="matchListFormGap" style="max-width: 31px"></div>
              <div class="deadlockDataPageMatchListFormTitleHeroNone matchListFormTitleItem">英雄</div>
              <div class="matchListFormGap" style="max-width: 35px"></div>
              <div class="deadlockDataPageMatchListFormTitleKDANone matchListFormTitleItem">KDA</div>
              <div class="matchListFormGap" style="max-width: 36px"></div>
              <div class="deadlockDataPageMatchListFormTitleSoulIconNone"></div>
              <div class="deadlockDataPageMatchListFormTitleSoulAndTimeNone matchListFormTitleItem">灵魂/时长</div>
            </div>
            <img class="noneImg" src="../../assets/image/deadlock/icon_WuNeirong_200x90@3x.png" alt="">
          </div>
        </div>
        <div class="deadlockDataPageSteamFriendsList">
              <div class="deadlockDataPageSteamFriendsTitle" @click="jumptoSteamFriendsList(friendList.length)">
                <div class="deadlockDataPageSteamFriendsTitleLeft">我的好友</div>
                <div class="deadlockDataPageSteamFriendsTitleRight" v-if="friendList.length > 0">
                  <div class="deadlockDataPageSteamFriendsTitleRightText">全部好友</div>
                  <div class="deadlockDataPageSteamFriendsTitleRightIcon"></div>
                </div>
              </div>
              <div class="deadlockDataPageSteamFriendsContent" v-if="friendList.length > 0">
                <div class="deadlockDataPageSteamFriendsContentHeader">
                  <div class="deadlockDataPageSteamFriendsFormTitleResult SteamFriendsFormTitleItem grid-row">玩家</div>
                  <div class="SteamFriendsFormGap grid-row" style="max-width: 20px"></div>
                  <div class="deadlockDataPageSteamFriendsFormTitleHero SteamFriendsFormTitleItem grid-row">场次</div>
                  <div class="SteamFriendsFormGap grid-row" style="max-width: 18px"></div>
                  <div class="deadlockDataPageSteamFriendsFormTitleKDA SteamFriendsFormTitleItem grid-row">KDA</div>
                  <div class="SteamFriendsFormGap grid-row" style="max-width: 20px"></div>
                  <div class="deadlockDataPageSteamFriendsFormTitleIcon grid-row"></div>
                  <div class="deadlockDataPageSteamFriendsFormTitleSoulAndTime SteamFriendsFormTitleItem grid-row">游民账号</div>
                </div>
                <div class="deadlockDataPageSteamFriendsContentInfo">
                  <div class="deadlockDataPageSteamFriendsFormItem" v-for="(item, index) in friendList" :key="index">
                    <div class="deadlockDataPageSteamFriendsFormItemResult grid-row" @click="toFriend(item.gsUserId,item.steamUsername,item.gsAvatar)">
                      <div class="deadlockDataPageSteamFriendsUserName">
                        <div class="userHeadImg">
                          <img :src="item.steamAvatar" alt="">
                        </div>
                        <div class="SteamFriendsUserName">{{ item.steamUsername }}</div>
                      </div>
                    </div>
                    <div class="SteamFriendsFormGap grid-row" @click="toFriend(item.gsUserId,item.steamUsername,item.gsAvatar)" style="max-width: 20px"></div>
                    <div class="deadlockDataPageSteamFriendsFormGameNumber grid-row" @click="toFriend(item.gsUserId,item.steamUsername,item.gsAvatar)" :class="{ noData: !item.baseTracker }">{{ item.baseTracker ? item.baseTracker.totalMatch : "--" }}</div>
                    <div class="SteamFriendsFormGap grid-row" @click="toFriend(item.gsUserId,item.steamUsername,item.gsAvatar)" style="max-width: 18px"></div>
                    <div class="deadlockDataPageSteamFriendsFormItemKDABox grid-row" @click="toFriend(item.gsUserId,item.steamUsername,item.gsAvatar)">
                      <div class="deadlockDataPageSteamFriendsFormItemKDA" :class="{ noData: !item.baseTracker }">{{ item.baseTracker ? item.baseTracker.kda : "--" }}</div>
                      <div class="deadlockDataPageSteamFriendsFormItemKDAData">
                        <div class="deadlockDataPageSteamFriendsFormItemKDADataInfo">
                          <div class="kill KDAInfo" :class="{ noData: !item.baseTracker }">{{ item.baseTracker ? item.baseTracker.kills : "--" }}</div>
                          <i class="KDAdivider">/</i>
                          <div class="death KDAInfo" :class="{ noData: !item.baseTracker }">{{ item.baseTracker ? item.baseTracker.deaths : "--" }}</div>
                          <i class="KDAdivider">/</i>
                          <div class="assists KDAInfo" :class="{ noData: !item.baseTracker }">{{ item.baseTracker ? item.baseTracker.assists : "--" }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="SteamFriendsFormGap grid-row" style="max-width: 20px"></div>
                    <div class="deadlockDataPageSteamFriendsFormItemIcon grid-row" @click="toFriendGamerskyPage(item.gsUserId)">
                      <img :src="item.gsAvatar ? item.gsAvatar : require('../../assets/image/deadlock/icon_MoRenTouXiang_36x36@3x.png')" alt="">
                    </div>
                    <div class="deadlockDataPageSteamFriendsFormItemUserName grid-row" @click="toFriendGamerskyPage(item.gsUserId)" :class="{ noData: !item.gsUsername }">{{ item.gsUsername ? item.gsUsername : "--" }}</div>
                  </div>
                </div>
              </div>
              <div class="deadlockDataPageSteamFriendsContentOfNone" v-else>
                <div class="deadlockDataPageMatchListContentHeaderNone">
                  <div class="deadlockDataPageMatchListFormTitleResultNone matchListFormTitleItem">玩家</div>
                  <div class="matchListFormGap" style="max-width: 20px"></div>
                  <div class="deadlockDataPageMatchListFormTitleHeroNone matchListFormTitleItem">场次</div>
                  <div class="matchListFormGap" style="max-width: 18px"></div>
                  <div class="deadlockDataPageMatchListFormTitleKDANone matchListFormTitleItem">KDA</div>
                  <div class="matchListFormGap" style="max-width: 20px"></div>
                  <div class="deadlockDataPageMatchListFormTitleSoulIconNone"></div>
                  <div class="deadlockDataPageMatchListFormTitleSoulAndTimeNone matchListFormTitleItem">游民账号</div>
                </div>
              <img class="noneImg" src="../../assets/image/deadlock/icon_WuNeirong_200x90@3x.png" alt="">
          </div>
        </div>
        <div class="deadlockDataPageTheEnd">
          <div class="deadlockDataPageTheEndImg"></div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import VueAwesomeSwiper from 'vue-awesome-swiper';
  import 'swiper/swiper-bundle.css'; 
  import deadlockApi from "../../assets/api/deadlockApi";
  import Header from "../../components/Header/HeaderDeadLock.vue";
  import { Toast } from 'vant';
  export default {
    name: "app",
    components: {
      Swiper: VueAwesomeSwiper.swiper,
      SwiperSlide: VueAwesomeSwiper.swiperSlide,
      Header
    },
    data() {
      return {
        swiperOptions: {
            centeredSlides: true,
            slidesPerView: 3,
            slideToClickedSlide: true,
            loop: true,
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            },
            autoplay: {
            delay: 3000,
            disableOnInteraction: false
            },
        },
        notHasGameData: 0,  
        baseTracker: {},
        userSteamName: "",
        userSteamAvatar: "",
        friendList: [],
        matchTrackerList: [],
        isFreshing: false,
        refreshState: false,
        gsFriendUserId: "",
        gsFriendUserName: "",
        gsFriendUserAvatar: "",
      };
    },
    mounted () {
      console.log(this.$utils.getQueryString("userId"));
      if(this.$utils.getQueryString("userId")){
        this.gsFriendUserId = this.$utils.getQueryString("userId");
        this.gsFriendUserName = decodeURIComponent(this.$utils.getQueryString("gsFriendUserName"));
        this.gsFriendUserAvatar = decodeURIComponent(this.$utils.getQueryString("gsAvatar"));
        this.notHasGameData = 2;
        this.getDeadLockData();
      }
      GSAppJsApi.EventStatistics.recordEvent("Z200217", "deadlock-战绩查询-访问量", 0);
      if(GSAppJsApi.User.getCurrentUserId() != 0){
        this.getUserBindInfo();
      }else{
        this.notHasGameData = 1;
      }
      GSAppJsApi.UI.registerNotificationListener("gamersky.app.steam.userbound", (response) => {
        this.getBindAccountToSteam(true);
      });
    },
    methods: {
        getBindAccountToSteam(bindListener = false){
          GSAppJsApi.User.loginTo((isComplated) => {
            if(isComplated){
                this.$toast({
                  type: "success",
                  message: "正在绑定",
                  time: 200000,
              });
              GSAppJsApi.EventStatistics.recordEvent("Z200219", "deadlock-战绩查询-请求绑定", 0);
                deadlockApi.getBindSteamByUserId({
                  userId: GSAppJsApi.User.getCurrentUserId(),
                }).then((res) => {
                  console.log(res);
                    if(res.data){
                        deadlockApi.userBind({
                          userId: GSAppJsApi.User.getCurrentUserId(),
                        }).then((res) => {
                          console.log(res);
                          if(res.status == 3 || res.status == 1){
                            // 绑定成功可以获取用户信息
                            this.$toast.close();
                            GSAppJsApi.EventStatistics.recordEvent("Z200220", "deadlock-战绩查询-绑定成功", 0);
                            this.getDeadLockData();
                            }
                          })
                    }else{
                        // 无steam绑定
                        this.$toast.close();
                        const a = document.createElement("a");
                        var url = `https://app.gamersky.com/oth/versionupgrade/?gsAppPageName=yongHu_BangDingSteam&gsAppPageTitle=绑定Steam`;
                        a.href = url;
                        a.click();
                        a.remove();
                    }
                })
            }
          })
        },
        getUserBindInfo(){
          deadlockApi.getUserBindInfo({
            userId: GSAppJsApi.User.getCurrentUserId(),
          }).then((res) => {
            console.log(res);
              if(res.status == 1){
                GSAppJsApi.EventStatistics.recordEvent("Z200218", "deadlock-战绩查询-已绑定访问量", 0);
                this.notHasGameData = 2;
                this.getDeadLockData();
              }else{
                this.notHasGameData = 1;
              }
            })
        },
        getDeadLockData() {
          if(this.gsFriendUserId != ""){
            deadlockApi.getUserTrackerInfo({
              gsUserId: this.gsFriendUserId,
            }).then((res) => {
              this.$toast.close();
              this.notHasGameData = 2;
                if(!res.error){
                  this.refreshState = false;
                  this.baseTracker = {};
                  this.userSteamAvatar = "";
                  this.userSteamName = "";
                  this.friendList = [];
                  this.matchTrackerList = [];
                  this.baseTracker = res.baseTracker;
                  this.userSteamAvatar = res.userInfo.steamAvatar;
                  this.userSteamName = res.userInfo.steamUsername;
                  this.friendList = res.friendList;
                  this.matchTrackerList = res.matchTrackerList;
                }
              })
          }else{
            deadlockApi.getUserTrackerInfo({
              gsUserId: GSAppJsApi.User.getCurrentUserId(),
            }).then((res) => {
              this.$toast.close();
              this.notHasGameData = 2;
                if(!res.error){
                  if(this.refreshState){
                    this.$toast({
                        type: "success",
                        message: "刷新成功",
                        time: 2000,
                    });
                    this.refreshState = false;
                    this.baseTracker = {};
                    this.userSteamAvatar = "";
                    this.userSteamName = "";
                    this.friendList = [];
                    this.matchTrackerList = [];
                  }
                  this.baseTracker = res.baseTracker;
                  this.userSteamAvatar = res.userInfo.steamAvatar;
                  this.userSteamName = res.userInfo.steamUsername;
                  this.friendList = res.friendList;
                  this.matchTrackerList = res.matchTrackerList;
                }
              })
          }

        },
        refreshData (){
          this.isFreshing = true;
          this.baseTracker.beUpdating = true;
          deadlockApi.update({
            gsUserId: GSAppJsApi.User.getCurrentUserId(),
          }).then((res) => {
            this.getRefreshState();
          })
        },
        getRefreshState () {
          var stateFlag = true;
          var getState = setInterval(() => {
            if(stateFlag){
              stateFlag = false;
              deadlockApi.getUpdateStatus({
                gsUserId: GSAppJsApi.User.getCurrentUserId(),
              }).then((res) => {
                if(res.error){
                  window.clearInterval(getState)
                  this.$toast({
                        type: "error",
                        message: "刷新失败",
                        time: 2000,
                    });
                }else{
                  stateFlag = true;
                  if(!res.beUpdating){
                    this.isFreshing = false;
                    this.baseTracker.beUpdating = false;
                    window.clearInterval(getState)
                    this.refreshState = true;
                    this.getDeadLockData();
                  }else{
                    this.isFreshing = true;
                    this.baseTracker.beUpdating = true;
                  }
                }
              })
            }

          }, 1000);
        },

        toFriend (userId,gsFriendUserName,gsAvatar) {
          this.$utils.openWithNewWindow(this.$utils.getCurrentUrl() + 'deadlock.html?appStatusBarStyle=kLightBar', {userId: userId, gsFriendUserName: encodeURIComponent(gsFriendUserName), gsAvatar: encodeURIComponent(gsAvatar)})
        },
        toFriendGamerskyPage(gsId){
          const f = document.createElement("a");
          var url = "//i.gamersky.com/u/" + gsId;
          f.href = url;
          f.click();
          f.remove();
        },
        gotoReport() {
            this.$utils.openWithNewWindow("https://club.gamersky.com/activity/946580");
        },
        jumpToMatchList(mathchListLength){
          if(mathchListLength > 0){
            this.$utils.openWithNewWindow(this.$utils.getCurrentUrl() + 'deadlockMatchList.html?appStatusBarStyle=kLightBar', {})
          }else{
            return;
          }
        },
        jumptoSteamFriendsList(steamFriendsListLength) {
          if(steamFriendsListLength > 0){
            this.$utils.openWithNewWindow(this.$utils.getCurrentUrl() + 'deadlockSteamFriendsList.html?appStatusBarStyle=kLightBar', {})
          }else{
            return;
          }
        },
        formatDuration(seconds){
          var minutes = Math.floor(seconds / 60);
          var remainingSeconds = seconds % 60;
          return `${minutes}m${remainingSeconds}s`;
        },


    }
  };
  </script>
  
  <style lang="scss">
  .swiper-wrapper {
      align-items: center;
  }
  
  .swiper-slide {
      display: flex;
      justify-content: center;
      align-items: center;
  
      img {
          width: 120px;
      }
  
  }
  
  .swiper-slide-active,
  .swiper-slide-duplicate-active {
      z-index: 100;
  
      img {
          width: 158px;
      }
  }
  
  .swiper {
      margin-bottom: 8px;
  }
  
  .swiper-pagination {
      position: static !important;
      height: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      // margin-bottom: 8px;
      margin-top: 8px;
  
      .swiper-pagination-bullet {
          display: block;
          background: rgba(255, 255, 255, 0.4);
          opacity: 1;
          width: 4px;
          height: 4px;
      }
  
      .swiper-pagination-bullet-active {
          background: rgba(255, 255, 255, 0.8);
      }
  }
  </style>
  
  
  <style lang="scss" scoped>
  #app {
      position: relative;
      margin: 0 auto;
      background: transparent;
      box-sizing: border-box;
      width: 100%;
      min-height: 100vh;
      // background: #3F362C url("../../assets/image/deadlock/数据展示页面的固定背景@3x.png") no-repeat center top / 700px 100%;
      // background-attachment: fixed;

      .noData {
        font-family: PingFang SC;
        font-size: 12px;
        font-weight: normal;
        line-height: normal;
        letter-spacing: 0px;
        color: rgba(255, 255, 255, 0.3) !important;
      }

      .deadlock-bg {
        position: fixed;
        left: 50%;
        top: 0;
        transform: translateX(-50%);
        width: 100%;
        max-width: 700px;
        height: 100vh;
        background: #3F362C url("../../assets/image/deadlock/数据展示页面的固定背景@3x.png") no-repeat center top / 700px 100%;
        z-index: 0;
      }

      .deadlock {
        //   padding-top: 171px;
          box-sizing: border-box;
          max-width: 700px;
          min-height: 100vh;
          margin: 0 auto;
          background: #3F362C url("../../assets/image/deadlock/绑定页面固定背景@3x.png") no-repeat center top / 700px 100%;
          display: flex;
          // justify-content: center;
          flex-direction: column;
          z-index: 1;
      }
  
      .deadlock-title {
          height: 102px;
          width: 100%;
          display: flex;
          justify-content: center;
          align-content: center;
          margin-top: 49px;
  
          .title-img {
              width: 138px;
              height: 79px;
          }
      }
  
      .deadlock-content {
          height: auto;
          padding-top: 20px;
          margin-top: 33px;
      }
      .deadlock-btn{
        border-radius: 6px;
        background: #D0D9E1;
        width: 265px;
        height: 40px;
        margin: 0 auto 12px;
        margin-top: 20px;
        font-family: PingFang SC;
        font-size: 16px;
        font-weight: 500;
        line-height: normal;
        text-align: center;
        letter-spacing: 0px;
        color: #222222;
        line-height: 40px;
      }
      .deadlock-report {
            position: fixed;
            left: 50%;
            bottom: 46px;
            transform: translateX(-50%);
            font-size: 14px;
            color: rgba(255, 255, 255, 0.8017);
            border-bottom: 0.5px solid rgba(255, 255, 255, 0.8004);
        }

      .deadlockDataPage {
        position: relative;
          box-sizing: border-box;
          max-width: 694px;
          min-height: 80vh;
          margin: 0 auto;
          // overflow-y: auto;
          overflow-x: hidden;
          
          display: flex;
          // justify-content: center;
          flex-direction: column;
          padding-left: 16px;
          padding-right: 16px;
          z-index: 1;

          .deadlockDataPageTitle {
            height: 36px;
            width: 100%;
            margin: 14px 0 14px 0;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-content: center;

            .deadlockDataPageTitleLeft{

              display: flex;
              flex-direction: row;
              align-items: center;
              height: 36px;
              

              .deadlockDataPageTitleLeftHeadIMG {
                  width: 36px;
                  height: 36px;
                img {
                  width: 36px;
                  height: 36px;
                  background-repeat: no-repeat; 
                  background-position: center center; 
                  background-size: 36px;
                  border-radius: 4px;
                }

              }
              .deadlockDataPageTitleLeftName {
                margin-left: 12px;
                height: 24px;
                width: auto;
                font-family: PingFang SC;
                font-size: 15px;
                font-weight: 500;
                line-height: 24px;
                letter-spacing: 0px;
                color: #FFFFFF;
                max-width: 140px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }

            }

            .deadlockDataPageTitleRight{
              display: flex;
              flex-direction: row;
              align-items: center;


              .deadlockDataPageTitleRightTimeShow {
                // height: 12px;
                // border-radius: 2.5px;
                opacity: 1;
                background: rgba(0, 0, 0, 0.2);
                display: flex;
                flex-direction: row;
                align-items: center;
                padding: 2px 4px;
                border-radius: 2.5px 0px 0px 2.5px;


                .deadlockDataPageTitleRightTimeShowText{
                    height: 12px;
                    font-family: PingFang SC;
                    font-size: 10px;
                    font-weight: normal;
                    display: flex;
                    align-items: center;
                    letter-spacing: 0px;
                    color: #FFFFFD;
                    opacity: 0.5;
                }


              }
              .deadlockDataPageTitleRightReflash{
                border-radius: 2px;
                opacity: 1;
                background: rgba(255, 255, 255, 0.3);
                display: flex;
                flex-direction: row;
                align-items: center;
                padding: 2px 4px;
                cursor: pointer;

                .deadlockDataPageTitleRightReflashIcon{
                  width: 12px;
                  height: 12px;
                  background: url("../../assets/image/deadlock/icon_ShuXin_14x14.svg");

                }
                .isFreshing {
                  background-size: cover;
                  animation: rotateAnimation 2s infinite; 
                }
                @keyframes rotateAnimation {
                  0% {
                    transform: rotate(0deg);
                  }
                  50% {
                    transform: rotate(180deg); 
                  }
                  100% {
                    transform: rotate(360deg); 
                  }
                }
                .deadlockDataPageTitleRightReflashText{
                  font-family: PingFang SC;
                  font-size: 10px;
                  font-weight: normal;
                  letter-spacing: 0px;
                  color: #FFFFFD;
                }

              }
              .archiveInfo-refresh {
                display: flex;
                align-items: center;
                height: 16px;
                border-radius: 0px 2.5px 2.5px 0px;
                background: rgba($color: #000000, $alpha: .2);
                overflow: hidden;
                font-size: 10px;
                color: rgba($color: #FFFFFD, $alpha: .5);
                line-height: 16px;
                // padding-left: 4px;
                white-space: nowrap;
                box-sizing: border-box;

                div {
                    display: flex;
                    align-items: center;
                    line-height: 17px;
                    height: 100%;
                    padding: 0 4px;
                    overflow: hidden;
                    font-size: 10px;
                    color: #FFFFFD;
                    background: rgba($color: #FFFFFF, $alpha: .3);
                    border-radius: 2.5px;
                    // margin-left: 4px;
                    white-space: nowrap;

                    &.cur {
                        i {
                            animation: rotate 1s linear infinite
                        }
                    }

                    i {
                        display: block;
                        width: 12px;
                        height: 12px;
                        background: url("//image.gamersky.com/webimg13/db/WukongGameArchive/archiveInfo-refresh.png") no-repeat center / 100%;
                        margin-right: 2px;
                    }

                    @keyframes rotate {
                        to {
                            transform: rotate(360deg);
                        }
                    }

                }
            }

            }

          }
          .deadlockDataPageOverViewData {
            height: 105px;
            margin-bottom: 8px;
            display: grid;
            grid-template-columns: repeat(4,1fr);
            grid-gap: 5px;
            margin-bottom: 8px;

            .OverViewData {
              min-width: 52px;
              height: 50px;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              background: url("../../assets/image/deadlock/核心数据-背景蒙版.svg") no-repeat center center / 100% auto;
            }
            .OverViewDataInfo {
              font-family: PingFang SC;
              font-size: 14px;
              font-weight: 500;
              line-height: 18px;
              text-align: center;
              letter-spacing: 0px;
              color: rgba(255, 255, 255, 0.8);
            }
            .OverViewDataText{
              font-family: PingFang SC;
              font-size: 9px;
              font-weight: normal;
              line-height: 12px;
              text-align: center;
              letter-spacing: 0px;
              color: rgba(255, 255, 255, 0.4);
            }
          }

          .deadlockDataPageLogo {
            // width: 158px;
            height: 22px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;


            .deadlockDataPageLogoImg{
              width: 158px;
              height: 18px;
              padding: 2px 12px;
              border-radius: 11px;
              opacity: 1;
              background: rgba(0, 0, 0, 0.15);
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              background: url("../../assets/image/deadlock/img_logo_158x22@3x.png") no-repeat center center / 158px 22px;
            }

          }

          .deadlockDataPageMatchList {
            display: flex;
            flex-direction: column;
            width: 100%;
            min-width: 343px;
            height: auto;
            margin-top: 24px;

            .deadlockDataPageMatchListTitle {
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: space-between;
              cursor: pointer;
              padding: 5px 0px 5px 0px;

              .deadlockDataPageMatchListTitleLeft {
                font-family: PingFang SC;
                font-size: 15px;
                font-weight: 500;
                line-height: 22px;
                letter-spacing: 0px;
                color: rgba(255, 255, 255, 0.8);
              }
              .deadlockDataPageMatchListTitleRight {
                display: flex;
                flex-direction: row;
                align-items: center;

                .deadlockDataPageMatchListTitleRightText {
                  font-family: PingFang SC;
                  font-size: 12px;
                  font-weight: normal;
                  text-align: right;
                  letter-spacing: 0px;
                  color: rgba(255, 255, 255, 0.5);
                }
                .deadlockDataPageMatchListTitleRightIcon {
                  width: 10px;
                  height: 10px;
                  background: url("../../assets/image/deadlock/icon_ LinearArrowRight_10x10_White@3x.png") no-repeat center center / 10px 10px;
                }

              }

            }

            .deadlockDataPageMatchListContent {
                display: grid;
                grid-template-columns: minmax(58px, 1fr) minmax(0, 31px) 40px minmax(0, 35px) minmax(68px, 1fr) minmax(0, 36px) 16px minmax(45px, 1fr);
                gap: 0; 
                min-width: 343px; 
                grid-auto-rows: 28px repeat(auto-fill, 52px);

                .deadlockDataPageMatchListContentHeader,
                .deadlockDataPageMatchListContentInfo {
                    display: contents;
                  .grid-row {
                    border-width: 0px 0px 0.5px 0px;
                    border-style: solid;
                    border-color: rgba(255, 255, 255, 0.05);
                    margin-bottom: 1px;
                  }
                }
                .deadlockDataPageMatchListContentHeader {



                  .matchListFormTitleItem {
                    font-family: PingFang SC;
                    font-size: 10px;
                    font-weight: normal;
                    line-height: 12px;
                    text-align: center;
                    letter-spacing: 0px;
                    color: rgba(255, 255, 255, 0.3);
                    height: 12px;
                    padding: 8px 0 8px 0;
                  }
                  .deadlockDataPageMatchListFormTitleResult {
                    min-width: 58px;
                    flex-grow: 1;
                  }
                  .deadlockDataPageMatchListFormTitleHero {
                    width: 40px;
                    flex-grow: 0;
                  }
                  .deadlockDataPageMatchListFormTitleKDA {
                    min-width: 68px;
                    flex-grow: 1;
                  }
                  .deadlockDataPageMatchListFormTitleSoulIcon {
                    width: 16px;
                  }
                  .deadlockDataPageMatchListFormTitleSoulAndTime {
                    min-width: 45px;
                    flex-grow: 1;
                    display: flex; 
                    flex-direction: column; 
                    align-items: flex-start;
                  }
                }

                .deadlockDataPageMatchListFormItem {
                    display: contents;
                }

                .matchListFormTitleItem,
                .deadlockDataPageMatchListFormTitleResult,
                .deadlockDataPageMatchListFormFormItemResult,
                .deadlockDataPageMatchListFormFormItemHero,
                .deadlockDataPageMatchListFormFormItemKDA,
                .deadlockDataPageMatchListFormFormItemSoulIcon,
                .deadlockDataPageMatchListFormFormItemSoulAndTime {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .deadlockDataPageMatchListFormItem {
                  .deadlockDataPageMatchListFormFormItemResult {
                    min-width: 58px;
                    flex-grow: 1;
                    display: flex;
                    flex-direction: row;
                    height: 52px;

                    .deadlockDataPageMatchListFormItemResultLineSuccess{
                      opacity: 1;
                      background: #259C27;
                      width: 2px;
                      height: 52px;
                    }
                    .deadlockDataPageMatchListFormItemResultLineFail{
                      opacity: 1;
                      background: #5B2525;
                      width: 2px;
                      height: 52px;
                    }
                    .deadlockDataPageMatchListFormItemResultInfo {
                      display: flex;
                      flex-direction: column;
                      // min-width: 56px;
                      flex-grow: 1;
                      height: 52px;

                      .matchsResultTest {
                        font-family: PingFang SC;
                        font-size: 12px;
                        font-weight: normal;
                        line-height: normal;
                        text-align: center;
                        letter-spacing: 0px;
                        color: rgba(255, 255, 255, 0.8);
                      }

                      .matchsResultSuccess {
                        border-radius: 0px 0px 4px 0px;
                        opacity: 1;
                        background: #259C27;
                        height: 20px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                      }
                      .matchsResultFail {
                        border-radius: 0px 0px 4px 0px;
                        opacity: 1;
                        background: #5B2525;
                        height: 20px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                      }
                      .matchsDate {
                        font-family: PingFang SC;
                        font-size: 10px;
                        font-weight: normal;
                        line-height: 16px;
                        letter-spacing: 0px;
                        color: rgba(255, 255, 255, 0.5);

                        height: 16px;
                        margin-top: 6px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                      }

                    }
                    
                  }
                  .deadlockDataPageMatchListFormFormItemHeroBox{ 
                    width: 40px;
                    height: 52px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                  }
                  .deadlockDataPageMatchListFormFormItemHero {
                    flex-grow: 0;
                    position: relative;
                    width: 40px;
                    height: 40px;
                    flex-grow: 0;
                    background: linear-gradient(0deg, rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.15));
                    border-radius: 2px;
                    overflow: hidden;
                      
                    img {
                        width: 100%;
                        height: 100%;
                    }

                    .deadlockDataPageMatchListFormItemHeroLevel {
                        position: absolute;
                        bottom: 0;
                        right: 0;
                        width: 20px;
                        height: 12px;
                        border-radius: 4px 0 2px 0;
                        opacity: 0.8;
                        background-color: rgba(0, 0, 0, 0.5);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: #fff;
                        font-size: 10px;
                        font-weight: 500;
                        font-family: PingFang SC;
                    }
                  }
                  .deadlockDataPageMatchListFormFormItemKDA {
                    min-width: 68px;
                    flex-grow: 1;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    height: 52px;
                    overflow: hidden;

                    .deadlockDataPageMatchListFormItemKDA {
                      height: 17px;
                      font-family: PingFang SC;
                      font-size: 12px;
                      font-weight: normal;
                      line-height: normal;
                      letter-spacing: 0px;
                      color: rgba(255, 255, 255, 0.8);
                    }
                    .deadlockDataPageMatchListFormItemKDAData {
                      height: 16px;
                      width: 100%;
                      overflow: hidden;

                      .deadlockDataPageMatchListFormItemKDADataInfo {
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        align-items: center;
                        flex-shrink: 0;
                        .KDAInfo {
                          font-family: PingFang SC;
                          font-size: 10px;
                          font-weight: normal;
                          line-height: 16px;
                          letter-spacing: 0px;
                          color: rgba(255, 255, 255, 0.6);
                        }
                        .KDAdivider {
                          // width: 4px;
                          font-family: PingFang SC;
                          font-size: 8px;
                          font-weight: normal;
                          line-height: 16px;
                          letter-spacing: 0px;
                          color: rgba(255, 255, 255, 0.3);
                          margin: 0 2px 0 2px;
                        }


                      }
                    }

                  }
                  .deadlockDataPageMatchListFormFormItemSoulIcon {
                    // margin-top: 10px;
                    width: 16px;
                    height: 52px;
                    // background: url("../../assets/image/deadlock/icon_LingHun_16x16.svg") no-repeat center / 16px 16px;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    img {
                      width: 16px;
                      height: 16px;
                      margin-top: -15px;
                    }
                  }
                  .deadlockDataPageMatchListFormFormItemSoulAndTime {
                    min-width: 45px;
                    flex-grow: 1;
                    display: flex; 
                    flex-direction: column; 
                    align-items: flex-start;

                    .deadlockDataPageMatchListFormItemSoul {
                      font-family: PingFang SC;
                      font-size: 12px;
                      font-weight: normal;
                      line-height: normal;
                      letter-spacing: 0px;
                      color: rgba(255, 255, 255, 0.8);
                      height: 17px;
                    }
                    .deadlockDataPageMatchListFormItemUseTime {
                      font-family: PingFang SC;
                      font-size: 10px;
                      font-weight: normal;
                      line-height: 16px;
                      letter-spacing: 0px;
                      color: rgba(255, 255, 255, 0.5);
                      height: 16px;
                    }

                  }
                }
            }
            .deadlockDataPageMatchListContentOfNone {
              display: flex;
              flex-direction: column;
              width: 100%;
              align-items: center;


              .deadlockDataPageMatchListContentHeaderNone {
                display: flex;
                flex-direction: row;
                min-width: 343px;
                width: 100%;

                .matchListFormTitleItem {
                    font-family: PingFang SC;
                    font-size: 10px;
                    font-weight: normal;
                    line-height: 12px;
                    text-align: center;
                    letter-spacing: 0px;
                    color: rgba(255, 255, 255, 0.3);
                    height: 12px;
                    padding: 8px 0 8px 0;
                  }
                .deadlockDataPageMatchListFormTitleResultNone {
                  min-width: 58px;
                  height: 12px;
                  flex-grow: 1;
                }
                .deadlockDataPageMatchListFormTitleHeroNone {
                  width: 40px;
                  height: 12px;
                }
                .deadlockDataPageMatchListFormTitleKDANone {
                  min-width: 68px;
                  height: 12px;
                  flex-grow: 1;
                }
                .deadlockDataPageMatchListFormTitleSoulIconNone {
                  width: 16px;
                  height: 12px;
                }
                .deadlockDataPageMatchListFormTitleSoulAndTimeNone {
                  min-width: 45px;
                  height: 12px;
                  flex-grow: 1;
                }

              }
              .noneImg {
                margin-top: 28px;
                width: 200px;
                height: 90px;
              }

            }


          }

          .deadlockDataPageSteamFriendsList {
            display: flex;
            flex-direction: column;
            width: 100%;
            min-width: 343px;
            // height: auto;
            margin-top: 24px;
            margin-bottom: 24px;

            .deadlockDataPageSteamFriendsTitle {
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: space-between;
              cursor: pointer;
              padding: 5px 0px 5px 0px;

              .deadlockDataPageSteamFriendsTitleLeft {
                font-family: PingFang SC;
                font-size: 15px;
                font-weight: 500;
                line-height: 22px;
                letter-spacing: 0px;
                color: rgba(255, 255, 255, 0.8);
              }
              .deadlockDataPageSteamFriendsTitleRight {
                display: flex;
                flex-direction: row;
                align-items: center;

                .deadlockDataPageSteamFriendsTitleRightText {
                  font-family: PingFang SC;
                  font-size: 12px;
                  font-weight: normal;
                  text-align: right;
                  letter-spacing: 0px;
                  color: rgba(255, 255, 255, 0.5);
                }
                .deadlockDataPageSteamFriendsTitleRightIcon {
                  width: 10px;
                  height: 10px;
                  background: url("../../assets/image/deadlock/icon_ LinearArrowRight_10x10_White@3x.png") no-repeat center center / 10px 10px;
                }

              }

            }

            .deadlockDataPageSteamFriendsContent {
                display: grid;
                grid-template-columns: minmax(112px, 1fr) minmax(0, 20px) minmax(30px, 1fr) minmax(0, 18px) minmax(68px, 1fr) minmax(0, 20px) 20px minmax(54px, 1fr);
                gap: 0; 
                min-width: 343px; 
                grid-auto-rows: 28px repeat(auto-fill, 52px);
                .grid-row {
                    border-width: 0px 0px 0.5px 0px;
                    border-style: solid;
                    border-color: rgba(255, 255, 255, 0.05);
                    margin-bottom: 1px;
                  }

                .deadlockDataPageSteamFriendsContentHeader,
                .deadlockDataPageSteamFriendsContentInfo {
                    display: contents;
                }
                .deadlockDataPageSteamFriendsContentHeader {
                  height: 28px;

                  .SteamFriendsFormTitleItem {
                    font-family: PingFang SC;
                    font-size: 10px;
                    font-weight: normal;
                    line-height: 12px;
                    text-align: center;
                    letter-spacing: 0px;
                    color: rgba(255, 255, 255, 0.3);
                    height: 12px;
                    padding: 8px 0 8px 0;
                  }
                  .SteamFriendsFormGap {
                    max-width: 36px;
                    width: 100%
                  }
                  .deadlockDataPageSteamFriendsFormTitleResult {
                    min-width: 112px;
                    flex-grow: 1;
                    display: flex; 
                    flex-direction: column; 
                    align-items: flex-start;
                  }
                  .deadlockDataPageSteamFriendsFormTitleHero {
                    min-width: 30px;
                    flex-grow: 0;
                    justify-content: flex-start;
                  }
                  .deadlockDataPageSteamFriendsFormTitleKDA {
                    min-width: 68px;
                    flex-grow: 1;
                  }
                  .deadlockDataPageSteamFriendsFormTitleIcon {
                    width: 20px;
                  }
                  .deadlockDataPageSteamFriendsFormTitleSoulAndTime {
                    min-width: 54px;
                    flex-grow: 1;
                    display: flex; 
                    flex-direction: column; 
                    align-items: flex-start;
                  }
                }

                .deadlockDataPageSteamFriendsFormItem {
                    display: contents;
                    
                }

                .SteamFriendsFormTitleItem,
                .deadlockDataPageSteamFriendsFormTitleResult,
                .deadlockDataPageSteamFriendsFormItemResult,
                .deadlockDataPageSteamFriendsFormGameNumber,
                .deadlockDataPageSteamFriendsFormItemKDABox,
                .deadlockDataPageSteamFriendsFormItemIcon{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .SteamFriendsFormGap {
                    max-width: 20px;
                }

                .deadlockDataPageSteamFriendsFormItem {
                  cursor: pointer;
                  .deadlockDataPageSteamFriendsFormItemResult {
                    min-width: 112px;
                    flex-grow: 1;
                    display: flex;
                    flex-direction: row;
                    height: 52px;

                    .deadlockDataPageSteamFriendsFormItemResultLineSuccess{
                      opacity: 1;
                      background: #259C27;
                      width: 2px;
                      height: 52px;
                    }
                    .deadlockDataPageSteamFriendsFormItemResultLineFail{
                      opacity: 1;
                      background: #5B2525;
                      width: 2px;
                    }
                    .deadlockDataPageSteamFriendsUserName {
                      // display: flex;
                      // flex-direction: row;
                      display: grid;
                      grid-template-columns: 30px 1fr;
                      gap: 0;
                      align-items: center;
                      // min-width: 56px;
                      flex-grow: 1;
                      height: 52px;


                      .userHeadImg {
                        width: 30px;
                        height: 30px;
                        overflow: hidden;
                        border-radius: 2px;

                        img {
                          width: 100%;
                          height: 100%;
                        }

                      }
                      .SteamFriendsUserName {
                        font-family: PingFang SC;
                        font-size: 11px;
                        font-weight: normal;
                        line-height: normal;
                        letter-spacing: 0px;
                        color: #FFFFFF;

                        height: 16px;
                        // margin-top: 6px;
                        display: inline-block;
                        justify-content: flex-start;
                        align-items: center;
                        margin-left: 4px;

                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        padding-right: 10px;

                        
                      }

                    }
                    
                  }
                  .deadlockDataPageSteamFriendsFormGameNumber {
                    font-family: PingFang SC;
                    font-size: 12px;
                    font-weight: normal;
                    line-height: normal;
                    letter-spacing: 0px;
                    color: #FFFFFF;
                    justify-content: flex-start;
                  }
                  .deadlockDataPageSteamFriendsFormItemKDABox {
                    min-width: 68px;
                    flex-grow: 1;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    height: 52px;
                    overflow: hidden;

                    .deadlockDataPageSteamFriendsFormItemKDA {
                      height: 17px;
                      font-family: PingFang SC;
                      font-size: 12px;
                      font-weight: normal;
                      line-height: normal;
                      letter-spacing: 0px;
                      color: rgba(255, 255, 255, 0.8);
                    }
                    .deadlockDataPageSteamFriendsFormItemKDAData {
                      height: 16px;
                      width: 100%;
                      overflow: hidden;

                      .deadlockDataPageSteamFriendsFormItemKDADataInfo {
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        align-items: center;
                        flex-shrink: 0;
                        .KDAInfo {
                          font-family: PingFang SC;
                          font-size: 10px;
                          font-weight: normal;
                          line-height: 16px;
                          letter-spacing: 0px;
                          color: rgba(255, 255, 255, 0.6);
                        }
                        .KDAdivider {
                          // width: 4px;
                          font-family: PingFang SC;
                          font-size: 8px;
                          font-weight: normal;
                          line-height: 16px;
                          letter-spacing: 0px;
                          color: rgba(255, 255, 255, 0.3);
                          margin: 0 2px 0 2px;
                        }


                      }
                    }

                  }
                  .deadlockDataPageSteamFriendsFormItemIcon {
                    
                    img {
                      width: 20px;
                      height: 20px;
                      border-radius: 50%;
                      background-repeat: no-repeat; 
                      background-position: center center; 
                      background-size: 16px;
                      align-self: center;
                    }

                  }
                  .deadlockDataPageSteamFriendsFormItemUserName {
                    align-self: center;
                    height: 52px;
                    min-width: 74px;
                    flex-grow: 1;
                    font-family: PingFang SC;
                    font-size: 9px;
                    font-weight: normal;
                    line-height: 52px;
                    letter-spacing: 0px;
                    color: #FFFFFF;
                    display: inline-block;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    padding-right: 10px;
                    // margin-left: 4px;
                    padding-left: 4px;
                  }
                }
            }

            .deadlockDataPageSteamFriendsContentOfNone {
              display: flex;
              flex-direction: column;
              width: 100%;
              align-items: center;


              .deadlockDataPageMatchListContentHeaderNone {
                display: flex;
                flex-direction: row;
                min-width: 343px;
                width: 100%;

                .matchListFormTitleItem {
                    font-family: PingFang SC;
                    font-size: 10px;
                    font-weight: normal;
                    line-height: 12px;
                    text-align: center;
                    letter-spacing: 0px;
                    color: rgba(255, 255, 255, 0.3);
                    height: 12px;
                    padding: 8px 0 8px 0;
                  }
                .deadlockDataPageMatchListFormTitleResultNone {
                  min-width: 58px;
                  height: 12px;
                  flex-grow: 1;
                }
                .deadlockDataPageMatchListFormTitleHeroNone {
                  width: 40px;
                  height: 12px;
                }
                .deadlockDataPageMatchListFormTitleKDANone {
                  min-width: 68px;
                  height: 12px;
                  flex-grow: 1;
                }
                .deadlockDataPageMatchListFormTitleSoulIconNone {
                  width: 16px;
                  height: 12px;
                }
                .deadlockDataPageMatchListFormTitleSoulAndTimeNone {
                  min-width: 45px;
                  height: 12px;
                  flex-grow: 1;
                }

              }
              .noneImg {
                margin-top: 28px;
                width: 200px;
                height: 90px;
              }

            }

          }
          .deadlockDataPageTheEnd {
            height: 20px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            width: 100%;
            margin-bottom: 24px;
            padding-bottom: 24px;

            .deadlockDataPageTheEndImg {
              width: 125px;
              height: 20px;
              padding: 2px 12px;
              border-radius: 11px;
              opacity: 1;
              background: rgba(0, 0, 0, 0.15);
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              background: url("../../assets/image/deadlock/end_banner@3x.png") no-repeat center center / 125px 20px;
            }

          }

      }
  
  }
  </style>
  